<template>
    <SmartLinkItemComponent :id="siteCfg?.system?.id" :component="!siteCfg?.system?.workflow">        
        <div class="global-header">
            <div class="container">
                <div class="navbar navbar-expand-lg">
                    <NuxtLink to="/" class="navbar-brand" @click="collapseNavbar">
                        <SmartLinkStandaloneElement :codename="type.elements.website_logo.codename">
                            <NuxtImg v-if="firstOrDefault(siteCfg.elements.website_logo.value)" :src="siteCfg.elements.website_logo.value[0].url" :alt="siteCfg.elements.site_name.value" class="logo" />
                        </SmartLinkStandaloneElement>
                    </NuxtLink>
                    <button class="navbar-toggler" type="button" @click="toggleNavbar" :aria-expanded="isNavOpen" aria-label="Toggle navigation">
                        <IconHamburger v-if="!isNavOpen" />
                        <IconX v-else />
                    </button>
                    <div :class="['navbar-collapse', isNavOpen ? 'show' : 'collapse']" id="navbarToggler">
                        <SmartLinkStandaloneElement :codename="type.elements.navigation_header.codename">
                            <ul class="navbar-nav">                    
                                <NavigationItemComponent v-for="(item, i) in siteStore.headerNavigationItems" :model="item" :index="i" :key="i" />                               
                            </ul>
                        </SmartLinkStandaloneElement>                                                                                                          
                    </div>
                </div>
            </div>
        </div>        
    </SmartLinkItemComponent>
</template>

<script lang="ts" setup>
import { ref, provide } from 'vue'
import { contentTypes } from '~/models';

const type = contentTypes.site_configuration;
const siteStore = useSiteStore();
const siteCfg = siteStore.siteConfig;

const isNavOpen = ref(false)

const toggleNavbar = () => {
  isNavOpen.value = !isNavOpen.value
}

const collapseNavbar = () => {
  isNavOpen.value = false
}

provide('collapseNavbar', collapseNavbar)
</script>
